import React from 'react'
import { useState } from 'react'
import StudiosBatches from "../studioBatches.json"

const AlQuasis = () => {
    const [toggleTab,setToggleTab] = useState(0)

    const [program,setProgram] = useState("Red")
    const handleToggle = (index,prog) => {
        setToggleTab(index)
        setProgram(prog)
    }

   

  return (
    <div className='BurCityLocation'>

        <div className="burcityLocationImg">
                <div className="locationNameResponsive">
                    <p>Al Quasis</p>
                    <div className="currentLocation">
                        <img src="/assets/locationMarker.svg" alt="" />
                        <span>Office No: M-05, M Floor (Mezzanine Floor) Al-Tawr 5, Next to Al Quasis metro station - Al Qusais </span>
                    </div>
                </div>
            <div className="locationImg">
                <img src="assets/locations/alQuasis.png" alt="" />
            </div>
            <div className="locationMap">
                <div className="locationName">
                    <p>Al Quasis</p>
                    <div className="currentLocation">
                        <img src="/assets/locationMarker.svg" alt="" />
                        <span>Office No: M-05, M Floor (Mezzanine Floor) Al-Tawr 5, Next to Al Quasis metro station - Al Qusais </span>
                    </div>
                </div>
                <div className="mapLocation">
                {/* <iframe style={{border:"0px"}} src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d367.0248488711791!2d55.3801079!3d25.2705493!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f5d44dba0a5e9%3A0x2bc4890eca9b5a16!2sTIME%20Grand%20Plaza%20Hotel!5e1!3m2!1sen!2sin!4v1671289191739!5m2!1sen!2sin" width="100%" height="100%"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}
                <iframe style={{border:"0px"}} src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d28864.147834038027!2d55.3796133!3d25.2699638!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f5daf372d33c9%3A0x56ffe8b35b0dfd98!2sARZOO%20BUILDING!5e0!3m2!1sen!2sin!4v1770199312325!5m2!1sen!2sin" width="100%" height="100%" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
            </div>
        </div>


        <div className="contactDetails d-flex justify-content-end" style={{marginTop:"10px"}}>
                <div className="callDetails">
                    <img src="/assets/callIcon.png" alt="" />
                    <a className='text-black'  href='tel:971585759017'>
                        <p>+971 5863 40992</p>
                        </a>
                </div>

                <div className="callDetails" style={{marginLeft:"40px"}}>
                <a
                      rel='noreferrer'
                      target='_blank'
                      href={`https://wa.me/971585759017?text=Hi%20I%20am%20interested%20in%20joining%20the%20${program}%20program.%20Can%20you%20please%20share%20more%20details.%20Thanks%20`}
                      // {user!==null || undefined ? user?.firstName.split(" ")[0]:""}
                     >
                    <img src="assets/whatsappIcon.png" alt="" />
                    <p className='BookNow' style={{textDecoration:"underline"}}>Book Now</p>
                </a>
                </div>
            </div>

        <div className="divider"></div>

       <div className="TabsContainer">

        <div className='ClassTabContent'>
            <h2>Batch Timings</h2>
        </div>
        

        <div className='d-flex'>
             {/* ================RED Time======================== */}
                {toggleTab == 0 && 
                
                <div className="ClassTabContent d-flex align-items-start timing-container">

                    <div>
                        <h3 style={{marginBottom:"5px"}}>AM (Morning): Duration - 1 Hour</h3>
                    
                        <div className="normalTime flex-wrap">
                            {
                                StudiosBatches.AlQuasis.map((item)=>(
                                    item.NormalBatch.map((value)=>(
                                        value?.batch == "morning" ?
                                        <span className={`batch-time ${item.id === "Red" ? "red-bg" : ""}`}>{value.time}</span> : <></>
                                    ))  
                                        
                                ))
                            }

                            {
                                StudiosBatches.AlQuasis.map((item)=>(
                                    item.LadiesBatch && item.LadiesBatch.map((value)=>(
                                            value?.batch == "morning" ?
                                            <span className={`batch-time ${item.id === "Red" ? "red-bg" : ""}`}>{value.time}</span> : <></>
                                        ))        
                                    ))
                            }

                        </div>
                    </div>
                    

                    <div>
                        <h3 style={{marginBottom:"5px"}}>PM (Evening): Duration - 1 Hour</h3>
                        <div className="normalTime">
                            {
                                StudiosBatches.AlQuasis.map((item)=>(
                                    item.NormalBatch && item.NormalBatch.map((value)=>(
                                        value?.batch == "evening" ?
                                        <span className={`batch-time ${item.id === "Red" ? "red-bg" : ""}`}>{value.time}</span> : <></>
                                    ))        
                                ))
                            }

                            { StudiosBatches.AlQuasis.map((item)=>(
                                item?.LadiesBatch?.length > 0 && <div className="ladiesTime">
                                {
                                    StudiosBatches.AlQuasis.map((item)=>(
                                        item.LadiesBatch && item.LadiesBatch.map((value)=>(
                                            value?.batch == "evening" ?
                                            <span className={`batch-time ${item.id === "Red" ? "red-bg" : ""}`}>{value.time}</span> : <></>
                                        ))        
                                    ))
                                }
                        </div>))}
                        
                        </div>
                    </div>
                </div>}
        </div>
        
        <div className='d-flex align-items-center'>
            <div className="differentiate ClassTabContent d-flex gap-1 align-items-center">
                <div className="ay-indicator"></div>
                <span style={{marginLeft:"3px",fontSize:"13px",fontWeight:"300"}}>AY Classic</span>
            </div>
             <div className="differentiate ClassTabContent d-flex gap-1 align-items-center">
                <div className="red-indicator"></div>
                <span style={{marginLeft:"3px",fontSize:"13px",fontWeight:"300"}}>Red</span>
            </div>
        </div>
       

        </div>

       
    </div>
  )
}

export default AlQuasis